import { render, staticRenderFns } from "./product_dev.vue?vue&type=template&id=475f8572&scoped=true"
import script from "./product_dev.vue?vue&type=script&lang=js"
export * from "./product_dev.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475f8572",
  null
  
)

export default component.exports